import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type CreateMedicationFormForListViewMutation} from './__generated__/queries.api-types';

const domain = 'MODALS/NEW_MEDICATION_FORM_ANY_CHILD';

export const {action: show} = createAction(`${domain}/SHOW`, (institutionId: string) => ({
    institutionId,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: created} = createAction(
    `${domain}/CREATED`,
    (medicationForm: CreateMedicationFormForListViewMutation) => ({medicationForm}),
);

export const {action: setIsLoading} = createAction(`${domain}/SET_IS_LOADING`, (isLoading: boolean) => ({isLoading}));
